import { Component, EventEmitter, Output } from '@angular/core';
import { AuthService } from 'src/app/Service/auth.service';

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./../../Pages/landing/landing.component.css'],
    standalone: false
})
export class PricingComponent {
  @Output() onCancel = new EventEmitter();
  constructor(public auth: AuthService) {}

 
}
